import styled from "styled-components";

export const Instructions = styled('div')<{ color?: string }>`
  font-family: ${({ theme }) => theme.type.fonts.main};
  color: ${(props) => props.color ? props.color : '#747B89'};
  font-weight: bold;
  width: 100%;
  text-align: center;
`;